module.exports = __webpack_public_path__ + "static/media/img1-en-desktop.882f037c.png";